module.exports = __webpack_public_path__ + "static/media/bs.4de1962d.svg";